"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ComparisonProductSelector = _interopRequireDefault(require("./ComparisonProductSelector"));
var _ComparisonDataDisplay = _interopRequireDefault(require("./ComparisonDataDisplay"));
var _useComparisonSpecs2 = _interopRequireDefault(require("../../hooks/comparison/useComparisonSpecs"));
var _useComparison2 = _interopRequireDefault(require("../../hooks/comparison/useComparison"));
var _useScrollToTop = require("../../hooks/app/useScrollToTop");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NegativeMarginWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: -24px;\n  margin-right: -24px;\n  overflow: hidden;\n  ", "\n\n  ", "\n"])), _r10SourceLibrary.Mixins.respondTo.md("margin-left: -32px;margin-right: -32px;"), _r10SourceLibrary.Mixins.respondTo.lg("margin-left: -40px;margin-right: -40px;"));
var isObjEmpty = function isObjEmpty(obj) {
  return Object.keys(obj).length === 0;
};
var ComparisonBody = function ComparisonBody() {
  var _useComparison = (0, _useComparison2.default)(),
    displayedProducts = _useComparison.displayedProducts;
  var _useComparisonSpecs = (0, _useComparisonSpecs2.default)(),
    specGroups = _useComparisonSpecs.specGroups;
  (0, _useScrollToTop.useScrollToTop)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(NegativeMarginWrapper, null, /*#__PURE__*/_react.default.createElement(_ComparisonProductSelector.default, null), specGroups.map(function (group, index) {
    return group.specs.some(function (el) {
      return !isObjEmpty(el.values);
    }) ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.default, {
      label: group.label,
      specs: group.specs,
      displayedProducts: displayedProducts
    }))) : null;
  }))));
};
var _default = ComparisonBody;
exports.default = _default;